import ApiService from "../../ApiService";

enum CheckUserDetailsEndpoints {
  CHECK_USER_DETAILS = "/employee/check-user-details",
}

export interface ICheckUserDetailsServiceResponse {
  success: boolean;
  message: string;
  missing_details: {
    [key: string]: Array<string>;
  };
}

class CheckUserDetailsService extends ApiService {
  async checkUserDetails(userId: string) {
    return this.get(
      `${CheckUserDetailsEndpoints.CHECK_USER_DETAILS}/${userId}`
    );
  }
}

export const checkUserDetailsService = new CheckUserDetailsService();
